import { css as cssStyles, styled } from 'canoe';
import isString from 'lodash/isString';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';
import { useMultiNodes } from 'craft/hooks';
import { useEnum } from 'craft/state';

const RatioLabel = styled.div`
  ${({ theme }) => cssStyles`
    padding: 0 ${theme.spaces.xs};
  `}
`;

interface Props {
  nodeIds: string[];
}

export const AspectRatioField = ({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds);
  const aspectRatios = useEnum('AspectRatios');

  const ratio = props.aspectRatio?.value;
  const onChangeAspect = (newAspect?: string | number) => {
    if (isString(ratio) && ratio === newAspect) {
      setProps({ aspectRatio: undefined });
    } else {
      setProps({ aspectRatio: newAspect, height: 'auto' });
    }
  };

  return (
    <>
      {aspectRatios?.values.map(({ value: aspectRatio }: { value: string }) => (
        <ValueToggle
          key={aspectRatio}
          toggleGroup="aspect-ratio"
          id={`aspect-ratio-${aspectRatio.replace(':', '-')}`}
          onClick={() => onChangeAspect(aspectRatio)}
          isActive={ratio === aspectRatio}
          label={<RatioLabel>{aspectRatio}</RatioLabel>}
        />
      ))}
    </>
  );
};
